export default __webpack_public_path__ + "static/media/shahcheragh.392b5de8.jpg";